import { lazy } from 'react';

import { Redirect, useRouteMatch } from 'react-router'

import { Page } from '@webapp/core/components/Page'
import { isUuid } from '@webapp/core/utils/isUuid'
import { useAppRoutes, useFeatureFlag, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type OrderDetailsPageParams, OrderStatusPageStatuses } from './types'
import { useGetBreadcrumbsPresenter } from '../features/get-breadcrumbs/presenter/useGetBreadcrumbsPresenter'

const LegacyOrderDetailsViewChunk = lazy(() =>
  import('../feature-sets/LegacyOrderDetailsView').then(
    ({ OrderDetailsView }) => ({
      default: OrderDetailsView,
    })
  )
)

const OrderDetailsViewChunk = lazy(() =>
  import('../feature-sets/OrderDetailsView').then(({ OrderDetailsView }) => ({
    default: OrderDetailsView,
  }))
)

export const OrderDetailsPage = () => {
  const intl = useProcurifyIntl()
  const PUR_2836_ORDER_LIFECYCLE_TRACKER = useFeatureFlag(
    'PUR_2836_ORDER_LIFECYCLE_TRACKER'
  )
  const { url } = useAppRoutes()
  const match = useRouteMatch<OrderDetailsPageParams>()
  const { uuid } = match.params

  const breadcrumbs = useGetBreadcrumbsPresenter({ orderUuid: uuid })

  // If uuid param is not a valid uuid, redirect to Order Status page
  if (!isUuid(uuid)) {
    return (
      <Redirect
        to={url('OrderStatusPage', {
          status: OrderStatusPageStatuses.PENDING,
        })}
      />
    )
  }

  return (
    <Page
      pageTitle={intl.formatMessage(messages.orderDetailsPageTitle)}
      breadcrumbs={breadcrumbs}
    >
      {PUR_2836_ORDER_LIFECYCLE_TRACKER ? (
        <OrderDetailsViewChunk />
      ) : (
        <LegacyOrderDetailsViewChunk />
      )}
    </Page>
  )
}
